import type { PropsWithChildren } from 'react';
import { Share2 } from 'lucide-react';

import { ReportWrapper } from '../components/ReportWrapper';

/**
 * Wrapper for the ecosystem graph tab of a Digital Footprint report. The graph
 * itself is injected by the consuming app (backoffice-v2's `EcosystemGraphSlot`)
 * so the Sigma/graphology rendering stack stays out of this shared package.
 */
export const EcosystemGraphSection = ({ children }: PropsWithChildren) => {
  return (
    <ReportWrapper
      title="Ecosystem Graph"
      Icon={Share2}
      tooltip="A graph of this report's ecosystem findings — related websites, companies and shared identifiers."
      showTooltip={false}
    >
      {children}
    </ReportWrapper>
  );
};
